import * as React from "react";
import { IUnitsAnalytics, IUser, SelectUnitName } from "../../../../App/Analytics/Common";
import {
  getUnitAnalyticsAverageTimesData,
  getUnitAnalyticsLessonsData,
  IUnitChartsInfo,
} from "../../../../parsers/analytics";
import {
  GridHeaderContainer,
  GridHeaderTitle,
  GridContentContainer,
  UnitsAnalyticsGridContainer,
} from "./UnitsAnalytics.styles";
import { SectionContainer, SectionTitle } from "../common/Charts.styles";
import { UnitCharts } from "./UnitsCharts";
import { UnitsIcon } from "../AnalyticsIcons";

interface IUnitsAnalyticsGraphProps {
  users: IUser[];
  unitsAnalytics: IUnitsAnalytics[];
  selected: Set<string>;
  selectUnitName: SelectUnitName;
}

export default class UnitsAnalyticsGraph extends React.PureComponent<IUnitsAnalyticsGraphProps, {}> {
  constructor(props: IUnitsAnalyticsGraphProps) {
    super(props);
    this.state = { showMore: false };
  }

  public render() {
    const { unitsAnalytics, users, selected, selectUnitName } = this.props;
    const isFilterActive = selected.size > 0;

    const values: IUnitChartsInfo[] = unitsAnalytics.map(unitAnalytics => ({
      lessons: getUnitAnalyticsLessonsData(users, unitAnalytics, selected),
      level: unitAnalytics.level,
      name: unitAnalytics.name,
      times: getUnitAnalyticsAverageTimesData(users, unitAnalytics, selected),
    }));

    const { maxStudents, maxAvgTime } = this.calculateMaxValues(values);

    return (
      <SectionContainer>
        <SectionTitle>
          <UnitsIcon />
          Chart for Individual Units
        </SectionTitle>
        <UnitsAnalyticsGridContainer>
          <GridHeaderContainer>
            <div /> {/* Empty div for spacing */}
            <GridHeaderTitle> Average Time Spent</GridHeaderTitle>
            <GridHeaderTitle> Number of Lessons Completed</GridHeaderTitle>
          </GridHeaderContainer>
          <GridContentContainer>
            {values.map((value: IUnitChartsInfo, index: number) => (
              <UnitCharts
                key={index}
                unitName={value.name}
                level={value.level}
                times={value.times}
                lessons={value.lessons}
                selectUnitName={selectUnitName}
                isFirst={index === 0}
                maxStudents={maxStudents}
                maxAvgTime={maxAvgTime}
                isFilterActive={isFilterActive}
              />
            ))}
          </GridContentContainer>
        </UnitsAnalyticsGridContainer>
      </SectionContainer>
    );
  }

  private calculateMaxValues = (values: IUnitChartsInfo[]) => {
    let maxAvgTime = -Infinity;
    let maxStudents = -Infinity;
    for (const value of values) {
      const times = value.times[0]["Average Time"];
      if (times > maxAvgTime) {
        maxAvgTime = times;
      }
      for (const lessons of value.lessons) {
        const students = lessons.students;
        if (students && students > maxStudents) {
          maxStudents = students;
        }
      }
    }
    return { maxAvgTime, maxStudents };
  };
}
